// removed by extract-text-webpack-plugin
module.exports = {"benefitsPoints":"benefitsPoints__1M-Mk"};


//////////////////
// WEBPACK FOOTER
// ./components/nfoPage/faq/faq.scss
// module id = 1219
// module chunks = 68